import { Component } from '@angular/core'
import { BaseCellComponent } from './base-cell.component'
import { BoolDisplayPipe } from 'src/app/shared/pipes/boolDisplay.pipe'

interface FlagCellProps<D> {
  flag: (data: D) => boolean
}

@Component({
  imports: [BoolDisplayPipe],
  styles: `
        :host {
            position: relative;
        }
    `,
  template: `
    @if(params.data){
      {{ params.flag(params.data) | boolDisplay }}
    }`,
})
export class FlagCellComponent<DATA> extends BaseCellComponent<
  DATA,
  FlagCellProps<DATA>,
  keyof DATA
> {}
